module.exports = require('./helpers/bundle-url').getBundleURL('9oV8V') + "logo.c51670a8.svg";